import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// src/use-image.ts
import { useSafeLayoutEffect } from "@chakra-ui/react-use-safe-layout-effect";
import { useCallback, useEffect, useRef, useState } from "react";
function useImage(props) {
  var loading = props.loading,
    src = props.src,
    srcSet = props.srcSet,
    onLoad = props.onLoad,
    onError = props.onError,
    crossOrigin = props.crossOrigin,
    sizes = props.sizes,
    ignoreFallback = props.ignoreFallback;
  var _useState = useState("pending"),
    _useState2 = _slicedToArray(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  useEffect(function () {
    setStatus(src ? "loading" : "pending");
  }, [src]);
  var imageRef = useRef();
  var load = useCallback(function () {
    if (!src) return;
    flush();
    var img = new Image();
    img.src = src;
    if (crossOrigin) img.crossOrigin = crossOrigin;
    if (srcSet) img.srcset = srcSet;
    if (sizes) img.sizes = sizes;
    if (loading) img.loading = loading;
    img.onload = function (event) {
      flush();
      setStatus("loaded");
      onLoad == null ? void 0 : onLoad(event);
    };
    img.onerror = function (error) {
      flush();
      setStatus("failed");
      onError == null ? void 0 : onError(error);
    };
    imageRef.current = img;
  }, [src, crossOrigin, srcSet, sizes, onLoad, onError, loading]);
  var flush = function flush() {
    if (imageRef.current) {
      imageRef.current.onload = null;
      imageRef.current.onerror = null;
      imageRef.current = null;
    }
  };
  useSafeLayoutEffect(function () {
    if (ignoreFallback) return void 0;
    if (status === "loading") {
      load();
    }
    return function () {
      flush();
    };
  }, [status, load, ignoreFallback]);
  return ignoreFallback ? "loaded" : status;
}
var shouldShowFallbackImage = function shouldShowFallbackImage(status, fallbackStrategy) {
  return status !== "loaded" && fallbackStrategy === "beforeLoadOrError" || status === "failed" && fallbackStrategy === "onError";
};
export { useImage, shouldShowFallbackImage };